import { render, staticRenderFns } from "./ReadingsSidebar.vue?vue&type=template&id=52cd1632&"
import script from "./ReadingsSidebar.vue?vue&type=script&lang=js&"
export * from "./ReadingsSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReadingsSidebar.vue"
export default component.exports